import React from 'react';
import styled from 'styled-components/macro';
import { space, SpaceProps } from 'styled-system';
import { useMediaQuery } from 'react-responsive';

import { Heading2, CapsLabel, Text } from '../SubComponents/Text';
import { Row } from '../SubComponents/Modals';
import useLocalize from '../Hooks/useLocalize';

const InfoWrapper = styled(Row)`
  max-width: 100%;
  flex-wrap: wrap;
  @media screen and (max-width: 767px) {
    max-width: 100%;
  }
`;

const InfoBlock = styled.div<SpaceProps>`
  display: flex;
  flex-direction: column;
  width: fit-content;
  padding-right: 20px;
  min-width: 50%;
  ${space}
`;

interface CustomerInfoProps {
  customer?: {
    firstname?: string | null;
    lastname?: string | null;
    email?: string | null;
    phone?: string | null;
    birthDate?: string | null;
  };
  recipient?: {
    name?: string;
  };
  showBirthDate?: boolean;
}

const CustomerInfo = ({ customer, recipient, showBirthDate }: CustomerInfoProps) => {
  const localize = useLocalize();
  const isMobile = useMediaQuery({ maxWidth: 767 });

  return (
    <>
      <Heading2 mb="2">{localize('product.yourInformation')}</Heading2>

      <InfoWrapper mb={recipient?.name ? '3' : isMobile ? '3' : '4'}>
        <InfoBlock mb="2">
          <CapsLabel>{localize('customer.firstname')}</CapsLabel>
          <Text>{customer?.firstname}</Text>
        </InfoBlock>
        <InfoBlock mb="2">
          <CapsLabel>{localize('customer.lastname')}</CapsLabel>
          <Text>{customer?.lastname}</Text>
        </InfoBlock>
        <InfoBlock mb="2">
          <CapsLabel>{localize('customer.email')}</CapsLabel>
          <Text>{customer?.email}</Text>
        </InfoBlock>
        <InfoBlock>
          <CapsLabel>{localize('customer.phone')}</CapsLabel>
          <Text>{customer?.phone}</Text>
        </InfoBlock>

        {showBirthDate && customer?.birthDate && (
          <InfoBlock>
            <CapsLabel>{localize('customer.birthDate')}</CapsLabel>
            <Text>{customer?.birthDate}</Text>
          </InfoBlock>
        )}
      </InfoWrapper>

      {recipient?.name && (
        <>
          <Heading2 mb="2">{localize('giftcard.recipientInformation')}</Heading2>
          <InfoWrapper mb={isMobile ? '3' : '4'}>
            <InfoBlock>
              <CapsLabel>{localize('recipient.name')}</CapsLabel>
              <Text>{recipient.name}</Text>
            </InfoBlock>
          </InfoWrapper>
        </>
      )}
    </>
  );
};

export default CustomerInfo;
